import React, { useEffect } from "react";
import * as echarts from "echarts";

const MonthWisePWILoadedEmptyGraph2HO = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const calcTotal = (data, section, key) =>
    selectedMonths.reduce((sum, month) => {
      const m = data.find((o) => o.month.slice(0, 3) === month);
      return sum + Number(getSectionData(m, section)[key] || 0);
    }, 0);

  useEffect(() => {
    if (!selectedMonths.length || !selectedSections.length) return;

    const chart = echarts.init(document.getElementById("HOpwiChart3"));
    const rt = selectedRT.toLowerCase();
    const prevFy = selectedFy.replace(/\d+/g, (y) => +y - 1);

    const sectionData = selectedSections
      .map((section) => {
        const prevHOL = calcTotal(sortedPrev, section, `${rt}_ho_loaded`);
        const currHOL = calcTotal(sortedCurr, section, `${rt}_ho_loaded`);
        const prevHOE = calcTotal(sortedPrev, section, `${rt}_ho_empty`);
        const currHOE = calcTotal(sortedCurr, section, `${rt}_ho_empty`);

        return {
          section,

          prevHOL,
          currHOL,
          prevHOE,
          currHOE,
          total: prevHOL + currHOL + prevHOE + currHOE,
        };
      })
      .sort((a, b) => b.total - a.total);

    const label = {
      show: true,
      position: "top",
      rotate: 55,
      fontSize: 12,
      verticalAlign: "middle",
    };

    const option = {
      title: {
        text: `HO L & E – Prev (${prevFy}) vs Curr (${selectedFy})`,
        left: "center",
      },
      tooltip: { trigger: "axis" },
      legend: {
        top: 30,
        data: [
          `H/O L (${prevFy})`,
          `H/O L (${selectedFy})`,
          `H/O E (${prevFy})`,
          `H/O E (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: sectionData.map((d) => d.section),
      },
      yAxis: { type: "value" },
      series: [
        {
          name: `H/O L (${prevFy})`,
          type: "bar",
          data: sectionData.map((d) => d.prevHOL),
          label,
        },
        {
          name: `H/O L (${selectedFy})`,
          type: "bar",
          data: sectionData.map((d) => d.currHOL),
          label,
        },
        {
          name: `H/O E (${prevFy})`,
          type: "bar",
          data: sectionData.map((d) => d.prevHOE),
          label,
        },
        {
          name: `H/O E (${selectedFy})`,
          type: "bar",
          data: sectionData.map((d) => d.currHOE),
          label,
        },
      ],
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [
    selectedMonths,
    selectedSections,
    sortedPrev,
    sortedCurr,
    selectedRT,
    selectedFy,
  ]);

  return (
    <div className="papaDiv">
      <div
        id="HOpwiChart3"
        style={{ width: "100%", height: "50vh", marginTop: "30px" }}
      />
    </div>
  );
};

export default MonthWisePWILoadedEmptyGraph2HO;
